import React from 'react'

import { Container, ContentHeader } from 'components'

import { Box } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import PlansForm from './components/PlansForm'
import useFetch from 'hooks/useFetch'
import * as service from 'service'

const PlansEdit = ({ match }) => {
  const { planId } = match.params

  const { response, isLoading } = useFetch(service.recurrence.plans.get, {
    planId,
  })

  return (
    <Container>
      <ContentHeader title="Plano" subtitle="Editar" />
      {isLoading ? (
        <Paper>
          <Box p={2}></Box>
        </Paper>
      ) : (
        <PlansForm planId={planId} plan={response.data.plan}></PlansForm>
      )}
    </Container>
  )
}

export default PlansEdit
